export enum TipoNI {
    CPF = 'CPF',
    CNPJ = 'CNPJ',
    CEI = 'CEI'
}

